import Vue from 'vue';
if(document.getElementById('pro-payment')){
    new Vue({
        el: '#pro-payment',
        data: {
            load: true,
            payment: {
                payment_1: false,
            }
        },
        computed: {
            proPayment() {
                return this.payment.payment_1;
            }
        }
    });
}
